import { EnrolCheckModel } from "@/composables/enrolement";
import AnimalViewer from "./animalviewer";
import { RowInformation } from "@/components/atoms/list";
import { UiButton } from "@/components/ui";
import { Save } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AnimalViewer2 from "./animal.viewer";

interface CheckAnimalResultProps {
  matricule: string;
  loading: boolean;
  enrol: EnrolCheckModel | null;
}
export default function CheckAnimalResult({
  matricule,
  loading,
  enrol,
}: CheckAnimalResultProps) {
  const navigate = useNavigate();

  return (
    <div>
      {!loading && (
        <div>
          {enrol !== null && (
            <div className="py-4 max-w-4xl-">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <h2 className="mb-1 font-semibold uppercase text-primary ">
                    Informations animal
                  </h2>
                  <div className="border border-1 border-black mb-4"></div>

                  {!enrol?.animal && (
                    <div className="bg-red-300 p-3">
                      <h2>
                        Désolé l'animal que vous rechercher est introuvable !
                      </h2>
                    </div>
                  )}
                  {enrol?.animal && <AnimalViewer2 animal={enrol?.animal} />}
                </div>
                {enrol?.infosMarqueur && (
                  <div>
                    <h2 className="mb-1 font-semibold uppercase text-primary ">
                      Informations marqueur
                    </h2>
                    <div className="border border-1 border-black mb-4"></div>

                    <div className="w-full">
                      <RowInformation
                        label="Campagne"
                        value={enrol?.infosMarqueur?.campagne ?? ""}
                      />
                      <RowInformation
                        label="Région"
                        value={enrol?.infosMarqueur?.region ?? ""}
                      />
                      <RowInformation
                        label="Ville"
                        value={enrol?.infosMarqueur?.ville ?? ""}
                      />
                      <RowInformation
                        label="Lot"
                        value={enrol?.infosMarqueur?.lot ?? ""}
                      />
                      <RowInformation
                        label="Sous Lot"
                        value={enrol?.infosMarqueur?.sousLot ?? ""}
                      />
                      <RowInformation
                        label="Boucle Dispo Lot"
                        value={enrol?.infosMarqueur?.boucleDispoLot ?? ""}
                      />
                      <RowInformation
                        label="Boucle Dispo Sous Lot"
                        value={enrol?.infosMarqueur?.boucleDispoSousLot ?? ""}
                      />

                      <RowInformation
                        label="Fabriqué par"
                        value={enrol?.infosMarqueur?.fabriquePar ?? ""}
                      />

                      <RowInformation
                        label="Prêt Pour Enrolement"
                        value={
                          enrol?.infosMarqueur?.pretPourEnrolement
                            ? "OUI"
                            : "NON"
                        }
                      />
                    </div>

                    {enrol?.infosMarqueur?.pretPourEnrolement && (
                      <div className="flex gap-2 flex-wrap items-center justify-start mt-8">
                        <UiButton
                          size="small"
                          className="flex gap-2 items-center"
                          onClick={() =>
                            navigate("/dashboard/enrolements/" + matricule)
                          }
                        >
                          <Save /> Faire l'enrolement
                        </UiButton>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
